<!-- 社区oto -->
<template>
  <div class="warp">
    <div class="banner">
      <br />
      <p>营销型社区O2O系统</p>
      <span>
        零技术门槛助您快速
        <br />搭建社区O2O平台
      </span>
      <a class="button-text" target="_blank" href="https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9">微信客服</a>
    </div>
    <div class="community01">
      <span class="title">什么是绿茶社区O2O系统？</span>
      <p>绿茶社区O2O系统是一款基于社区，涵盖社区物业、门禁、缴费、日常消费、上门O2O、社区社交等最贴近社区居民需求的O2O应用系统！它可以实现独立名称、独立风格、独立运营，为您打造属于您自己的社区O2O平台。</p>
      <img src="../../assets/images/community02.jpg" />
    </div>
    <div class="community02">
      <span class="title">绿茶一体化社区O2O体系多角色使用需求</span>
      <ul class="swiper-tab">
        <li @click="changeTab(1)" :class="indexActive==1?'indexActive':''">
          <span>用户</span>
        </li>
        <li @click="changeTab(2)" :class="indexActive==2?'indexActive':''">
          <span>配送/服务</span>
        </li>
        <li @click="changeTab(3)" :class="indexActive==3?'indexActive':''">
          <span>商家</span>
        </li>
        <li @click="changeTab(4)" :class="indexActive==4?'indexActive':''">
          <span>社区物业</span>
        </li>
        <li @click="changeTab(5)" :class="indexActive==5?'indexActive':''">
          <span>多级代理商</span>
        </li>
        <li @click="changeTab(6)" :class="indexActive==6?'indexActive':''">
          <span>平台运营商</span>
        </li>
      </ul>

      <swiper :options="swipersocial" ref="mySwiper">
        <!-- slides -->
        <swiper-slide class="swiper-item">
          <div class="box">
            <img src="../../assets/images/community03.jpg" />
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <div class="box">
            <img src="../../assets/images/community04.jpg" />
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <div class="box">
            <img src="../../assets/images/community05.jpg" />
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <div class="box">
            <img src="../../assets/images/community06.jpg" />
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <div class="box">
            <img src="../../assets/images/community07.jpg" />
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <div class="box">
            <img src="../../assets/images/community08.jpg" />
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="community03">
      <span class="title">绿茶社区O2O体系核心方案</span>
      <div class="item1">
        <div class="subtitle">
          <h3>
            <b>-</b>
            <span>01</span>
            <b></b>-
          </h3>
          <p>
            绿茶社区O2O打造业务与用户体验的闭环，
            <br />让运营服务踏实落地
          </p>
        </div>
        <ul>
          <li>
            <img src="../../assets/images/community10.png" />
            <span>搭建多用户社区O2O平台</span>
          </li>
          <li>
            <img src="../../assets/images/community11.png" />
            <span>多行业商户入驻</span>
          </li>
          <li>
            <img src="../../assets/images/community12.png" />
            <span>用户下单并支付</span>
          </li>
          <li>
            <img src="../../assets/images/community13.png" />
            <span>配送上门</span>
          </li>
          <li>
            <img src="../../assets/images/community14.png" />
            <span>分享评价</span>
          </li>
          <li>
            <img src="../../assets/images/community15.png" />
            <span>大数据服务</span>
          </li>
        </ul>
      </div>
      <div class="item2">
        <div class="subtitle">
          <h3>
            <b>-</b>
            <span>02</span>
            <b></b>-
          </h3>
          <p>
            多城市代理、拓宽销售渠道的同事各层级之间
            <br />互不干扰，灵活设置
          </p>
        </div>
        <ul>
          <li>
            <span>多城市灵活设置</span>
            <p>代理商根据代理权限划分</p>
            <b>不受地域限制，可同时发展多个城市的业务</b>
          </li>
          <li>
            <span>结算透明效率高</span>
            <p>系统自动生成报表进行代理商之间结算</p>
            <b>数字化流程简单透明、提高效率</b>
          </li>
          <li>
            <span>拓宽销售渠道</span>
            <p>不同代理商不同运营销售管理模式</p>
            <b>迅速拓张运营范围，覆盖全国，拓宽销售渠道</b>
          </li>
        </ul>
      </div>

      <div class="item3">
        <div class="subtitle">
          <h3>
            <b>-</b>
            <span>03</span>
            <b></b>-
          </h3>
          <p>社区物业数字化管理平台</p>
        </div>
        <ul>
          <li>
            <i class="left"></i>
            <i class="right"></i>
            <img src="../../assets/images/community21.png" />
            <div class="txt">
              <span>业主信息，身份审核，房产/资金/公告/保修管理...</span>
              <p>线上数字化物业信息，构建物业资讯线上共享、物业维修随手查，物业缴费一键通的智能信息化平台，为物业公司带来管理效率和服务质量的提升</p>
            </div>
          </li>
          <li>
            <i class="left"></i>
            <i class="right"></i>
            <img src="../../assets/images/community22.png" />
            <div class="txt">
              <span>物业缴费、生活缴费、故障报修、摇一摇开门禁...</span>
              <p>围绕业主各种家庭服务需求进行资源配置，服务更周到全面，同时节约大量人力成本和沟通成本</p>
            </div>
          </li>
        </ul>
      </div>

      <div class="item4">
        <div class="subtitle">
          <h3>
            <b>-</b>
            <span>04</span>
            <b></b>-
          </h3>
          <p>多种互动营销功能助您玩转流量</p>
        </div>
        <ul>
          <li>
            <img src="../../assets/images/community25.png" />
            <span>团购</span>
          </li>
          <li>
            <img src="../../assets/images/community26.png" />
            <span>优惠券</span>
          </li>
          <li>
            <img src="../../assets/images/community27.png" />
            <span>满减/满赠</span>
          </li>
          <li>
            <img src="../../assets/images/community28.png" />
            <span>积分商城</span>
          </li>
          <li>
            <img src="../../assets/images/community29.png" />
            <span>会员等级</span>
          </li>
          <li>
            <img src="../../assets/images/community30.png" />
            <span>签到有礼</span>
          </li>
          <li>
            <img src="../../assets/images/community31.png" />
            <span>抢购</span>
          </li>
          <li>
            <img src="../../assets/images/community32.png" />
            <span>分销拓客</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="community04">
      <span class="title">用户的声音</span>
      <swiper :options="swipersub" style>
        <swiper-slide class="swiper-item">
          <div class="list4">
            <p>“专门找的老牌子，果然没让我失望，技术确实很强！版本更新也比较快，一路关注过来，很多功能都在完善，用起来很方便”</p>
            <h2>
              <img src="../../assets/images/community33.png">
              <span>来自北京的吕先生</span>
            </h2>
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <div class="list4">
            <p>“和绿茶合作的过程很愉快，有什么问题，客服都会耐心解答，售后有疑问也都帮忙解决，有时候产品和技术人员还直接过来沟通帮忙，是你们负负责任的态度打动了我...”</p>
            <h2>
              <img src="../../assets/images/community33.png">
              <span>来自深圳的黄先生</span>
            </h2>
          </div>
        </swiper-slide>
        <swiper-slide class="swiper-item">
          <div class="list4">
            <p>“绿茶科技的实力还是可信赖的，运维团队很赞专业！像系统升级、偶尔出现一些bug要修复、有新的想法了想增加一些功能模块之类的直接找售后反应，很快就给我处理了”</p>
            <h2>
              <img src="../../assets/images/community33.png">
              <span>来自杭州的李先生</span>
            </h2>
          </div>
        </swiper-slide>
        <!-- Optional controls ,显示小点-->
        <div class="swiper-pagination swiper-pagination1" slot="pagination"></div>
      </swiper>
    </div>
    <div class="city7">
      <h3>专业的<span>营销型社区O2O系统</span></h3>
      <h4>我们不断进步的脚步，是为了给您带来最好的服务</h4>
      <button type="button" @click="toService">微信客服</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "community",

  data() {
    return {
      indexActive: 1,
      swipersocial: {
        // loop: true,
        speed: 500, //匀速时间
        on: {
          slideChangeTransitionEnd: function () {
            vm.indexActive = this.activeIndex + 1;
            // console.log(vm);
            // debugger;
          },
        },
      },

      swipersub: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        speed: 700,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: false,
        },
      },
    };
  },
  mounted() {},

  methods: {
    toService() {
      window.location.href =
        "https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9";
    },
    changeTab(i) {
      this.$nextTick(function () {
        this.$refs.mySwiper.swiper.slideTo(i - 1, 500, false);
        this.indexActive = i;
      });
    },
  },
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #fff;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 1.2rem;
  .banner {
    background: url("../../assets/images/community01.jpg") no-repeat left top;
    background-size: 100% auto;
    height: 7rem;
    padding: 0 0.5rem;
    padding-top: 2rem;
    color: #fff;
    p {
      font-size: 0.6rem;
    }
    span {
      font-size: 0.36rem;
      line-height: 0.6rem;
      display: block;
      padding-top: 0.2rem;
    }
    a {
      background-color: #fbb908;
      width: 3rem;
      height: 0.9rem;
      text-align: center;
      color: #fff;
      font-size: 0.36rem;
      border-radius: 0.9rem;
      margin-top: 0.5rem;
      line-height: 0.9rem;
      display: block;
    }
  }
  .title {
    display: block;
    font-size: 0.48rem;
    color: #262e43;
    text-align: center;
    padding: 0.5rem 0;
  }
  .community01 {
    padding: 0.5rem;
    padding-bottom: 0;
    p {
      font-size: 0.32rem;
      line-height: 0.655rem;
      text-indent: 2em;
      color: #6f6f6f;
    }
    img {
      width: 100%;
      margin: 0.2rem 0;
    }
  }
  .community02 {
    .swiper-tab {
      margin: 0 0.4rem 0.6rem;
      display: flex;
      justify-content: center;
      li {
        text-align: center;
        border: 1px solid #eee;
        border-right: 0;
        line-height: 0.8rem;
        background-color: #f6f8fb;
        padding: 0 0.26rem;
        white-space: nowrap;
        &:first-child {
          border-radius: 1rem 0 0 1rem;
        }
        &:last-child {
          border-right: 1px solid #eee;
          border-radius: 0 1rem 1rem 0;
        }
        span {
          color: #f6f8fb;
          font-size: 0.28rem;
          color: #666666;
        }
        &.indexActive {
          background-color: #2375ff;
          border-color: #2375ff;
          span {
            color: #fff;
          }
        }
      }
    }
    .box {
      img {
        width: 10rem;
        margin: 0 0.4rem;
      }
    }
  }
  .community03 {
    padding-top: 0.5rem;
    .subtitle {
      h3 {
        font-size: 0.5rem;
        color: #262e43;
        font-weight: 700;
        text-align: center;
        padding-bottom: 0.2rem;
        span {
          padding: 0 0.1rem;
        }
        b {
          font-weight: 400;
        }
      }
      p {
        font-size: 0.4rem;
        color: #262e43;
        text-align: center;
        line-height: 0.6rem;
        padding-bottom: 0.2rem;
      }
    }
    .item1 {
      background: url("../../assets/images/community09.jpg");
      padding: 0.8rem 0.3rem;
      ul {
        display: flex;
        flex-wrap: wrap;
        li {
          width: 33.333333%;
          text-align: center;
          padding: 0.3rem 0;
          img {
            width: 1.25rem;
          }
          span {
            font-size: 0.3rem;
            color: #258ffc;
            display: block;
            padding: 0.2rem 0;
          }
          &:nth-child(2n) {
            span {
              color: #f7750c;
            }
          }
        }
      }
    }
    .item2 {
      background: url("../../assets/images/community16.jpg");
      margin: 0.4rem 0;
      padding: 0.8rem 0.4rem;
      ul {
        li {
          &:nth-child(1) {
            background-image: url("../../assets/images/community17.jpg");
          }
          &:nth-child(2) {
            background-image: url("../../assets/images/community18.jpg");
          }
          &:nth-child(3) {
            background-image: url("../../assets/images/community19.jpg");
          }
          background-color: #fff;
          margin-top: 0.4rem;
          padding: 0 0.45rem;
          height: 3.24rem;
          background-repeat: no-repeat;
          background-size: 5rem auto;
          background-position: right center;
          span {
            font-size: 0.4rem;
            font-weight: 600;
            display: block;
            padding: 0.6rem 0 0.1rem;
          }
          p {
            font-size: 0.32rem;
            color: #898989;
          }
          b {
            color: #f7750c;
            font-size: 0.32rem;
            padding-top: 0.4rem;
            display: block;
          }
        }
      }
    }
    .item3 {
      background: url("../../assets/images/community20.jpg");
      margin: 0.4rem 0;
      padding: 0.8rem 0.4rem;
      ul {
        li {
          margin-top: 1.4rem;
          position: relative;
          background-color: #2b79ff;
          border-radius: 0.1rem;
          padding: 1.3rem 0.8rem 0.6rem 0.8rem;
          img {
            width: 2rem;
            height: 2rem;
            position: absolute;
            left: 50%;
            top: -1rem;
            margin-left: -1rem;
          }
          i {
            width: 0.4rem;
            height: 0.4rem;
            background: url("../../assets/images/community23.png") no-repeat
              center center;
            background-size: 0.4rem auto;
            display: block;
            position: absolute;
          }
          .left {
            top: 0.6rem;
            left: 0.4rem;
          }
          .right {
            bottom: 0.4rem;
            right: 0.4rem;
            transform: rotate(180deg);
          }
          .txt {
            color: #fff;
            font-size: 0.3rem;
            line-height: 0.55rem;
            span {
              display: block;
              text-align: center;
              padding-bottom: 0.1rem;
            }
          }
        }
      }
    }
    .item4 {
      background: url("../../assets/images/community24.png");
      margin: 0.4rem 0;
      padding: 0.8rem 0.4rem;
      ul {
        display: flex;
        flex-wrap: wrap;
        padding-top: 0.3rem;
        li {
          width: 25%;
          text-align: center;
          padding: 0.35rem 0;
          img {
            width: 1.5rem;
          }
          span {
            display: block;
            font-size: 0.3rem;
            padding: 0.2rem 0;
          }
        }
      }
    }
  }
  .community04 {
    background-color: #262e43;
    color: #fff;
    position: relative;
    height: 4.7rem;
    margin-bottom: 2.5rem;
    .title {
      color: #fff;
      padding: 0.8rem 0 0.9rem;
    }
    .swiper-container {
      height: 4.5rem;
      .swiper-slide {
        padding: 0 calc((100vw - 300px) * 0.1) !important;
        width: 300px !important;
        .list4 {
          background-color: #2b79ff;
          padding: 0.6rem;
          box-sizing: border-box;
          border-radius: 0.1rem;
          height: 3.3rem;
          p {
            font-size: 0.28rem;
            line-height: 0.5rem;
            margin-bottom: 0.3rem;
            height: 1.5rem;
            overflow: hidden;
          }
          h2 {
            text-align: right;
            font-weight: normal;
            font-size: 0.28rem;
            img {
              width: 0.38rem;
              height: 0.38rem;
              border-radius: 1rem;
            }
          }
        }
        &:nth-child(2n) {
          .list4 {
            background-color: #fbb908;
          }
        }
      }
    }
  }
  .city7 {
    height: 6.04rem;
    background: url("../../assets/images/community34.png") no-repeat center
      center;
    background-size: 100% auto;
    margin-top: 0.5rem;
    text-align: center;
    padding-top: 1.5rem;
    margin-bottom: -1rem;
    h3 {
      font-size: 0.6rem;
      font-weight: 500;
      span {
        color: #2b79ff;
      }
    }
    h4 {
      font-size: 0.36rem;
      font-weight: 400;
      color: #666;
      padding: 0.3rem 0 0.5rem;
    }
    button {
      height: 0.95rem;
      width: 3.5rem;
      background-color: #fbb908;
      border-radius: 1rem;
      color: #fff;
      font-size: 0.36rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/product/community.vue